import {ComponentProps, createElement, FC, JSX} from "react";
import {css, cx} from "@pandacss/css";


type ElementName = keyof JSX.IntrinsicElements;
type ClassName = undefined | string | string[];

const mergeClassNames = (a: ClassName, b: ClassName): string => {
    const allClasses: string[] = [];
    if (a) {
        allClasses.push(...(Array.isArray(a) ? a : [a]));
    }
    if (b) {
        allClasses.push(...(Array.isArray(b) ? b : [b]));
    }
    return cx(...allClasses);
}

const pointerClassName = css({
    cursor: 'pointer',
})

export const createPandaComponent = <T extends ElementName>(componentName: string, baseElementName: T, baseClassName: ClassName): FC<ComponentProps<T>> => {
    const Component: FC<ComponentProps<T>> = (props) => {
        const { className, children, onClick, ...rest } = props;
        const pointerClass = onClick ? pointerClassName : undefined;

        const mergedClassName = mergeClassNames(mergeClassNames(baseClassName, pointerClass), className, );

        return createElement(baseElementName, {
            className: mergedClassName,
            onClick,
            ...rest,
        }, children);
    }

    Component.displayName = componentName;

    return Component;
}